import packages from '../data/packagesData';

function Packages() {
  const handleWhatsAppClick = (pkgTitle) => {
    const phoneNumber = '62859106695506'; // Replace with your WhatsApp number
    const message = `Halo, saya mau reservasi paket photobooth MomenQ ${pkgTitle}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank'); // Open WhatsApp in a new tab
  };

  return (
    <section id="packages">
      <h2>Paket Layanan</h2>
      {/* <h3 className="promo-text" >Promo Juni 2026</h3> */}

      <div className="packages-container">
        {packages.map(pkg => (
          <div className="package-card" key={pkg.id}>
            <h3>{pkg.title}</h3>
            <p className="package-desc">{pkg.description}</p>

            {/* PRICE */}

            <div className="price">
              {pkg.price !== pkg.originalPrice && (
                <span className="original-price">
                  Rp {pkg.originalPrice.toLocaleString('id-ID')}
                </span>
              )}

              <span className="discount-price">
                Rp {pkg.price.toLocaleString('id-ID')}
              </span>
            </div>

            {/* FEATURES */}
            <ul className="features">
              {pkg.features.map((feature, index) => (
                <li key={index}>✓ {feature}</li>
              ))}
            </ul>

            <button
              className="package-btn"
              onClick={() => handleWhatsAppClick(pkg.title)}
            >
              Reservasi Sekarang
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Packages;
